import { useEffect, useState } from "react";
import Modal from "react-modal";
import CloudUpload from "../../../../../assets/images/commonIcons/CloudUpload.svg";
import trashIcons from "../../../../../assets/images/commonIcons/Trash.svg";
import { AddSupportingDoc } from "./AddSupportingDoc";
import {
  useGetBankDataQuery,
  useGetCompanyQuery,
  useGetOptimisedCompanyDetailsQuery,
} from "../../../../../store/Company/companyApiSlice";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaFileAlt } from 'react-icons/fa';
import bg1 from "../../../../../assets/images/billing-header.svg";

export const SupportingDocs = () => {
  const { token } = useSelector((state) => state.auth);
  const { id } = useParams();
  const { data } = useGetOptimisedCompanyDetailsQuery({
    companyId: id,
    token,
  });
  const { data: bankData } = useGetBankDataQuery({
    bankID: data?.bankDetails != null && data?.bankDetails != undefined && data?.bankDetails[0]?.bankID?.bankID,
    token,
  });

  useEffect(() => {
    if (data) {
    }
  }, [data]);

  useEffect(() => {
    if (bankData) {
    }
  }, [bankData]);

  const SupportingDocs = [];

  // if (data?.financialDetails[0]?.audited_financial_statement != null && data?.financialDetails[0]?.audited_financial_statement != undefined) {
  //   SupportingDocs.push({
  //     title: "Financial Statement",
  //     imageUrl: data?.financialDetails[0]?.audited_financial_statement,
  //     lastUpdated: "2 days ago",
  //   });
  // }

  if (data?.MOA) {
    SupportingDocs.push({
      title: "Memorandum of Association",
      imageUrl: data.MOA,
      lastUpdated: "1 day ago",
    });
  }

  if (data?.VAT_certificate) {
    SupportingDocs.push({
      title: "VAT certificate",
      imageUrl: data.VAT_certificate,
      lastUpdated: "2 days ago",
    });
  }

  if (data?.trade_license) {
    SupportingDocs.push({
      title: "Trade License",
      imageUrl: data.trade_license,
      lastUpdated: "2 days ago",
    });
  }


  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const SupportingDocsUploadDelete = () => {
    openModal();
  };

  return (
    <>
      <div className="p-2">
        {SupportingDocs.length > 0 && (
          <div className="bg-white rounded-xl p-6 mb-6">
            <h2 className="text-start text-primary text-[18px] sm:text-f18 font-semibold">Supporting Documents</h2>

            <div className="sm:grid sm:grid-cols-3 gap-4">
              {false && <AddSupportingDoc />}

              {SupportingDocs.map((supportingDoc) => (

                <Link to={supportingDoc?.imageUrl || "#"} target="_blank">
                  <div style={{
                    background: `url(${bg1}) no-repeat center center / cover`,
                    padding: '32px',
                  }} className="transition-transform transform hover:-translate-y-1 hover:scale-105 duration-300 rounded-xl shadow-lg my-4 hover:shadow-xl p-5">
                    <div className="flex flex-col items-center justify-center text-white">
                      <FaFileAlt size={40} className="mb-4" />
                      <h2 className="text-[18px] sm:text-f18 font-bold mb-2 text-center">
                        {supportingDoc.title}
                      </h2>
                      <span className="mt-2 text-[12px] sm:text-sm uppercase tracking-widest">Click to view</span>
                    </div>
                  </div>
                </Link>

              ))}
            </div>

            <Modal
              isOpen={isOpen}
              onRequestClose={closeModal}
              contentLabel="Upload Delete Confirmation"
              className="modal"
              overlayClassName="overlay"
            >
              <div className="w-[220px] sm:w-[250px]">
                <div className="w-full pb-2 text-end">
                  <button onClick={closeModal}>&#9587;</button>
                </div>
                <div className="">
                  <div className="pt-4">
                    <button className="flex">
                      <img src={CloudUpload} alt="CloudUploadIcon" />
                      <h3 className="text-[#3C4848] pl-2">Re - Upload Document</h3>
                    </button>
                  </div>

                  <div className="pt-4">
                    <button className="flex">
                      <img src={trashIcons} alt="trashIcon" />
                      <h3 className="text-[red] pl-2">Delete</h3>
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        )}
      </div>
    </>
  );
};
